import React from 'react';

export default () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='16'
    height='16'
    viewBox='0 0 16 16'
  >
    <path d='M2.476 10.67a.292.292 0 0 1 .274.078l2.499 2.5a.292.292 0 0 1-.117.483l-3.745 1.247a.292.292 0 0 1-.369-.37v.001l1.249-3.745a.292.292 0 0 1 .209-.193zm7.554-7.622a.3.3 0 0 1 .412 0l2.497 2.498a.292.292 0 0 1 0 .412l-6.657 6.657a.292.292 0 0 1-.413 0l-2.497-2.497a.292.292 0 0 1 0-.412zm1.458-1.455a2.108 2.108 0 0 1 2.91 0c.8.804.8 2.103 0 2.907l-.416.418a.292.292 0 0 1-.413 0l-2.496-2.496a.292.292 0 0 1 0-.413z' />
  </svg>
);
